import React, { useState } from 'react';
import { MapPin, Mail, Send, CheckCircle } from 'lucide-react';
import { contatoService } from '../services/api';
import './Contato.css';

export default function Contato() {
  const [form, setForm] = useState({ nome: '', email: '', assunto: '', mensagem: '' });
  const [loading, setLoading] = useState(false);
  const [sucesso, setSucesso] = useState(false);
  const [erro,    setErro]    = useState('');

  const onChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) =>
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const enviar = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setErro('');
    try {
      await contatoService.enviar(form);
      setSucesso(true);
      setForm({ nome: '', email: '', assunto: '', mensagem: '' });
    } catch {
      setErro('Não foi possível enviar sua mensagem. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main>
      <div className="page-hero">
        <h1>Entre em Contato</h1>
        <p>Tire suas dúvidas, faça parcerias ou saiba mais sobre nossas ações.</p>
      </div>

      <section className="section-pad">
        <div className="container">
          <div className="contato-grid">
            {/* Info */}
            <div className="contato-info">
              <h3>Informações de Contato</h3>
              <p>Estamos prontos para conversar sobre parcerias, projetos e voluntariado.</p>

              <div className="contato-items">
                <div className="contato-item">
                  <div className="ci-icon"><MapPin size={20} /></div>
                  <div>
                    <strong>Endereço</strong>
                    <span>Rua Amanda Rocha Mesquita de Oliveira, Quadra 19, Lote 07 – Residencial Tiradentes, Marabá – PA</span>
                  </div>
                </div>
                <div className="contato-item">
                  <div className="ci-icon"><Mail size={20} /></div>
                  <div>
                    <strong>E-mail</strong>
                    <a href="mailto:contato@maosestendidas.org.br">contato@maosestendidas.org.br</a>
                  </div>
                </div>
              </div>

              <div className="contato-cnpj">
                <span>CNPJ</span>
                <strong>45.334.670/0001-82</strong>
              </div>
            </div>

            {/* Form */}
            <div className="contato-form-wrap">
              {sucesso ? (
                <div className="contato-sucesso">
                  <CheckCircle size={48} />
                  <h3>Mensagem enviada!</h3>
                  <p>Obrigado pelo contato. Retornaremos em breve.</p>
                  <button className="btn btn-primary mt-16" onClick={() => setSucesso(false)}>Enviar outra</button>
                </div>
              ) : (
                <form onSubmit={enviar} className="contato-form">
                  <h3>Envie uma mensagem</h3>
                  {erro && <div className="alert alert-erro">{erro}</div>}

                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label">Seu nome *</label>
                      <input name="nome" value={form.nome} onChange={onChange} required className="form-control" placeholder="João da Silva" />
                    </div>
                    <div className="form-group">
                      <label className="form-label">E-mail *</label>
                      <input name="email" type="email" value={form.email} onChange={onChange} required className="form-control" placeholder="joao@email.com" />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Assunto *</label>
                    <select name="assunto" value={form.assunto} onChange={onChange} required className="form-control">
                      <option value="">Selecione um assunto</option>
                      <option value="parceria">Proposta de Parceria</option>
                      <option value="voluntariado">Voluntariado</option>
                      <option value="doacao">Doação</option>
                      <option value="projeto">Sobre um Projeto</option>
                      <option value="transparencia">Transparência / Documentos</option>
                      <option value="outro">Outro</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Mensagem *</label>
                    <textarea name="mensagem" value={form.mensagem} onChange={onChange} required className="form-control" placeholder="Escreva sua mensagem aqui…" rows={5} />
                  </div>
                  <button type="submit" className="btn btn-primary w-full" disabled={loading}>
                    {loading ? 'Enviando…' : <><Send size={16} /> Enviar mensagem</>}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
